module.exports = __webpack_public_path__ + "img/AA.459564db.jpg";